import React, { } from 'react';

import { theme, Layout, Avatar, Menu, Dropdown, Row, Col, Typography, Popover, Tooltip, Badge, Tabs, Button, List, Divider, Space } from 'antd';
import {
	UserOutlined,
	LogoutOutlined,
	DownOutlined,
} from '@ant-design/icons';


import './index.css';

import { JSXMap, useTranslateContext, ycStorage } from 'fennec-ui';

import { useNavigate } from 'react-router-dom';
import { useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { useDispatch, useSelector } from 'react-redux';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import Icofont from 'react-icofont';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { translate, ycBucket } from '../../../common/Tool';
import NotifyBlock from '../../components/NotifyBlock';
import StatusBlock from '../../components/StatusBlock';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLangSwitchContext, useLayoutWidthContext } from '../../../common/Context';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { useToken } = theme;

var _ = require('lodash');
const { SubMenu } = Menu;

const { Header } = Layout;

const FedHeader = (props) => {
	const { menu, children } = props;
	const auth = useAuth();
	let navigate = useNavigate();
	const langSwitch = useLangSwitchContext();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	// const t = React.useMemo(() => _.bind(translate, {
	// 	translate: translates,
	// 	config: userConfig
	// }), [translates, userConfig]);
	const t = useTranslateContext();
	// console.log(t("да"));

	const statusForHeader = (status, element, onlyNew) => {
		return status.filter((s) => {
			if (s.tipNovayaInfa == false) return false;
			return true;
		})
	};
	const notifyForHeader = (notify) => {
		return notify.filter((s) => {
			if (s.prochitano == true) return false;
			return true;
		})
	};

	const status = useSelector(state => state.home.status, () => { }); // Статусы
	const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	const { layout, fullwidth, user, logout, logoutall, hideLogo } = props;
	let lsDiv = (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" };
	let lsHeader = (layout === "web") ? { background: "white" } : {};
	let lsFontColor = (layout === "web") ? { color: "rgb(0 0 0 / 65%)" } : { color: "rgba(255, 255, 255, 0.65)" };

	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	const balance = (akkauntiPolzovatelei) => {
		let a = akkauntiPolzovatelei.find(e => e.akkaunt.akkauntTypeID == 2)
		let v = a?.akkaunt?.ostatok;
		if (v) return v;
		return 0;
	};

	const badgeCount = () => {
		var stat = statusForHeader(status);
		var noty = notifyForHeader(notify);
		return stat.length + noty.length
	};
	const { token } = useToken();
	const contentStyle = {
		backgroundColor: token.colorBgElevated,
		borderRadius: token.borderRadiusLG,
		boxShadow: token.boxShadowSecondary,
		padding: "10px"
	};
	const menuStyle = {
		boxShadow: 'none',
	};
	function getCurrencyValue(value, color) {
		if (!value) {
			return (<span style={{ color: "grey" }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
		if (color) {
			return (<span style={{ color: color }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
		if (value >= 0) {
			return (<span style={{ color: "rgb(63, 134, 0)" }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
		if (value < 0) {
			return (<span style={{ color: "red" }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
	}
	return (
		<Header className="header" style={{ padding: "0 10px", ...lsHeader }}>
			<div style={{ ...lsDiv, display: "flex", justifyContent: "space-between" }}>
				<div style={{ flex: "0 1 400px", display:"flex" }}>
					<div>
						{langSwitch}
					</div>
				</div>
				{(!hideLogo) && <div style={{ flex: "1 1 auto", display: "flex", justifyContent: "center" }}>
					<a href="/fed/events" target="_blank" rel="noreferrer noopener">
						{(layout === "web") && <img style={{ height: "48px" }} src="/resources/logo-blue.svg" alt="Logo" />}
						{(layout === "app") && <img style={{ height: "48px" }} src="/resources/logo.svg" alt="Logo" />}
					</a>
				</div>}
				<div style={{ flex: "0 1 400px" }}>
					{user && <div style={{ float: "right" }}>
						<Row style={{ cursor: "pointer" }}>
							<Col style={{ lineHeight: "20px", textAlign: "right" }}>
								<Typography style={{ ...lsFontColor, padding: "12px 15px 0px 0px", fontWeight: "600", fontSize: "13px" }}>
									{user.lastname} {user.firstname}
								</Typography>
								<Typography style={{ ...lsFontColor, padding: "0 15px", fontSize: "12px" }}>
									{/* {user.email} */}
									Баланс:
									<Popover placement="bottom" content={
										JSXMap(akkauntiPolzovatelei, (e, idx) => {
											return (<div key={idx} style={{ display: "flex", justifyContent: "space-between", gap: "55px", padding: (idx != 0) ? "10px 0px 0px 0px" : "" }}>
												<div>
													<div style={{ fontSize: "12px", color: "grey" }}>
														{(e?.akkaunt?.akkauntTypeID == 2) && <span>Основной счет</span>}
														{(e?.akkaunt?.akkauntTypeID == 9) && <span>Накопительный счет</span>}
													</div>
													<div>
														<span>№{e?.akkaunt?.nomerAkkaunta}</span>
													</div>
												</div>
												<div style={{ textAlign: "right" }}>
													{getCurrencyValue(e?.akkaunt?.ostatok)}
												</div>
											</div>)
										})


									} trigger="click">
										<a href="#" style={{ paddingLeft: "3px", color: (balance(akkauntiPolzovatelei) < 0) ? "red" : "#1890ff" }}>
											{balance(akkauntiPolzovatelei).toLocaleString()} руб.
										</a>
									</Popover>
								</Typography>
							</Col>
							<Col>
								<Dropdown
									// open={true}
									placement='bottomRight'
									menu={{
										items: menu,
									}}
									dropdownRender={(menu) => (
										<div style={contentStyle}>
											<div>
												<List>
													<List.Item
														style={{ padding: "4px 5px" }}
														// className={"bg bg-blue pointer"}
														className={"bg bg-fwhite pointer"}>
														<a style={{ fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
															<i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i> {t("Главный сайт")}
														</a>
													</List.Item>
													<List.Item
														style={{ padding: "4px 5px" }}
														// className={"bg bg-orange pointer"}
														className={"bg bg-fwhite pointer"}>
														<a style={{ fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
															<Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} /> {t("Личный кабинет")}
														</a>
													</List.Item>
													<List.Item
														style={{ padding: "4px 5px" }}
														// className={"bg bg-green pointer"}
														className={"bg bg-fwhite pointer"}>
														<a style={{ fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`}>
															<Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} /> {t("Войти в мероприятие")}
														</a>
													</List.Item>
													<List.Item
														style={{ padding: "4px 5px" }}
														// className={"bg bg-grey pointer"}
														className={"bg bg-fwhite pointer"}>
														<a style={{ fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
															<Icofont icon="user" style={{ fontSize: "13px" }} /> {t("Профиль")}
														</a>
													</List.Item>
												</List>
											</div>
											<Divider
												style={{
													margin: 0,
												}}
											/>
											{menu && React.cloneElement(menu, {
												style: menuStyle,
											})}
											{children}
											<Divider
												style={{
													margin: 0,
													paddingBottom: "5px"
												}}
											/>
											<div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "4px 5px" }} onClick={logout}>
												<div style={{ cursor: "pointer" }}><LogoutOutlined /> Выход</div>
												<div style={{ flex: 0, color: "red", cursor: "pointer" }} onClick={logoutall}>
													<Tooltip title="Выйти на всех устройствах">
														<Icofont icon="logout" />
													</Tooltip>
												</div>
											</div>
										</div>
									)}
								>
									<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} size="large" shape='square' icon={<UserOutlined style={{ padding: 0 }} />} />
								</Dropdown>
							</Col>
							<Col>
								<div style={{ paddingLeft: "10px" }}>
									<Dropdown placement="bottomRight" overlay={
										<div className='notify-bell' style={{ backgroundColor: "white", padding: "5px 10px", borderRadius: "3px", width: "350px", height: "500px", maxHeight: "500px", border: "1px solid #eee" }}>
											<Tabs defaultActiveKey="1" size='small'>
												<Tabs.TabPane tab="Статусы" key="1">
													<div style={{ position: "relative", display: "flex", flexDirection: "column", height: "100%" }}>
														<div style={{ flex: "1 1", overflowY: "auto", overflowX: "hidden", height: "100%" }}>
															<StatusBlock {...props} filters={() => []} compact={true} uuid="78a3e02024f2" />
														</div>
														<div style={{ display: "flex", flex: "0 0 35px", borderTop: "1px solid #eee", padding: "5px 0px" }}>
															<Button block size='large' style={{ width: "100%", textAlign: "center" }} onClick={() => navigate("common/notify/status")}>
																Просмотреть все статусы
															</Button>
														</div>
													</div>
												</Tabs.TabPane>
												<Tabs.TabPane tab="Оповещения" key="2">
													<div style={{ position: "relative", display: "flex", flexDirection: "column", height: "100%" }}>
														<div style={{ flex: "1 1", overflowY: "auto", overflowX: "hidden", height: "100%" }}>
															<NotifyBlock {...props} filters={() => []} compact={true} uuid="088648c5acda" />
														</div>
														<div style={{ display: "flex", flex: "0 0 35px", borderTop: "1px solid #eee", padding: "5px 0px" }}>
															<Button block size='large' style={{ width: "100%", textAlign: "center" }} onClick={() => navigate("common/notify/notifications")}>
																Просмотреть все оповещения
															</Button>
														</div>
													</div>
												</Tabs.TabPane>
											</Tabs>
										</div>
									}>
										<Badge size="small" offset={[-15, 8]} count={badgeCount()} overflowCount={99}>
											<Avatar shape="square" size="large" style={{ background: "#eee5" }} icon={<Icofont icon="alarm" style={{ color: "rgba(0, 0, 0, 0.25)" }} />} />
										</Badge>
									</Dropdown>
								</div>
							</Col>
						</Row>

					</div>}
				</div>
			</div>
		</Header>
	);
};

export default React.memo(FedHeader);
